module.exports = __webpack_public_path__ + "static/media/statistics.88e48b39.png";